module.exports = __webpack_public_path__ + "static/media/bgi-talentx-main-v2@3x.41e2ccfd.png";